// src/views/BackOffice/CreateBMO.js
import React from 'react';
import BMOFormWizard from '../../forms/BMOFormWizard';

const CreateBMO = () => {
  return <BMOFormWizard />;
};

export default CreateBMO;
